"use strict";

var Link = ReactRouter.Link;

var ShortcutItem = require('./shortcutItem');
var ToggleShortcut = require('../layout/toggleShortcut');

var Shortcut = React.createClass({

  propTypes: {
    moduleList: React.PropTypes.array,
    currentModule: React.PropTypes.object
  },

  render: function () {
    var {moduleList, currentModule} = this.props;
    moduleList = moduleList || [];
    currentModule = currentModule || {};

    return (
      <div id="shortcut">
        <ul>
          {moduleList.map((item, id) => {
            return <ShortcutItem
              key={id}
              module={item}
              isCurrentModule={currentModule.code == item.code}
            />
          })}
        </ul>
			<span className="minifyme">
				<ToggleShortcut>
					<i className="fa fa-chevron-circle-up"></i>
				</ToggleShortcut>
			</span>
      </div>
    );
  },

});

module.exports = Shortcut;
